import type { Permission } from '@gql'
import useUser from '@hooks/useUser'
import type { MatchAccessType } from '@sections/auth/access'
import { hasPermissions } from '@sections/auth/access'
import type React from 'react'
import type { PropsWithChildren } from 'react'

export function useHasPermission(
  permissions: readonly Permission[],
  matchPermission: MatchAccessType = 'all',
): boolean {
  const { user } = useUser()
  return !!user && hasPermissions(permissions, user, matchPermission)
}

export interface RequirePermissionsProps {
  permissions: readonly Permission[]
  matchPermission?: MatchAccessType
}

const WithPermissions: React.FC<PropsWithChildren<RequirePermissionsProps>> = ({
  children,
  permissions,
  matchPermission = 'all',
}) => {
  const { user } = useUser()
  return user && hasPermissions(permissions, user, matchPermission) ? <>{children}</> : null
}

WithPermissions.displayName = 'WithPermissions'
export default WithPermissions
